import React from "react"
// import { MyTableCellHelpers } from "@macashipo/mlib"
import { CSuppense } from "src/core/components"
const MyTCHtml = React.lazy(() => import("./Types/html"))
const MyTCReadonly = React.lazy(() => import("./Types/readonly"))
const MyTCExpandApi = React.lazy(() => import("./Types/expand_api"))
const MyTCReadonlyDate = React.lazy(() => import("./Types/readonly_date"))
const MyTCReadonlyDocument = React.lazy(
  () => import("./Types/readonly_document")
)
const MyTCLink = React.lazy(() => import("./Types/link"))
const MyTCCheckbox = React.lazy(() => import("./Types/checkbox"))
const MyTCModalPage = React.lazy(() => import("./Types/modal_page"))

const TableControls = {
  html: props => CSuppense(props, MyTCHtml),
  readonly_html: props => CSuppense(props, MyTCHtml),
  readonly: props => CSuppense(props, MyTCReadonly),
  readonly_date: props => CSuppense(props, MyTCReadonlyDate),
  expand_api: props => CSuppense(props, MyTCExpandApi),
  readonly_document: props => CSuppense(props, MyTCReadonlyDocument),
  link: props => CSuppense(props, MyTCLink),
  checkbox: props => CSuppense(props, MyTCCheckbox),
  modal_page: props => CSuppense(props, MyTCModalPage),
}

export default TableControls
